<template>
  <div class="reseller-list-wrapper">
    <div class="container">
      
      <!-- Header (Consistent with ProductDetail) -->
      <div class="nav-header animate-fade-in">
        <div class="nav-left">
          <v-btn icon @click="$router.push('/')" class="back-btn">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <span class="nav-title">Torna</span>
        </div>
        
        <router-link to="/" class="nav-logo-link">
          <img 
            src="https://masticando-cdn.s3.eu-west-1.amazonaws.com/logo-435x435.png" 
            alt="Masticando" 
            class="header-logo"
          />
        </router-link>
      </div>

      <div class="content-animate-up">
        <h2 class="page-title">{{getTranslation('reseller-list')}}</h2>
        <div class="title-underline"></div>
        

        <!-- Featured Reseller (Scientific Referent) -->
        <div class="reseller-section">
          <v-expansion-panels variant="accordion" class="custom-reseller-panels">
            <v-expansion-panel class="reseller-panel featured-panel">
              <v-expansion-panel-title class="panel-header">
                <div class="reseller-header-content">
                  <div class="badge">Referente Scientifico</div>
                  <h3>Dott. Pierluigi Raffo</h3>
                  <div class="subtitle">Esperto in masticazione e autore di "Evviva si mastica"</div>
                </div>
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <div class="reseller-details">
                  <div class="detail-group">
                    <h4><v-icon size="small" color="primary">mdi-phone</v-icon> Contatti</h4>
                    <a :href="`tel:+393488337333`">+39 348 833 7333</a>
                  </div>
                  <div class="detail-group">
                     <h4><v-icon size="small" color="primary">mdi-map-marker-radius</v-icon> Area di attività</h4>
                    <span>Tutta Italia</span>
                  </div>
                </div>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <!-- Search -->
        <div class="search-container glass-card">
          <v-text-field
            v-model="searchQuery"
            prepend-inner-icon="mdi-magnify"
            clearable
            label="Cerca per città, provincia, nome o attività"
            variant="plain"
            hide-details
            @update:model-value="debouncedSearch"
            class="custom-search-field"
          ></v-text-field>
        </div>

        <!-- Reseller List -->
        <div class="reseller-section">
           <v-expansion-panels variant="accordion" v-model="panels" class="custom-reseller-panels">
            <v-expansion-panel 
              v-for="reseller in filteredResellers" 
              :key="reseller.id"
              class="reseller-panel"
            >
              <v-expansion-panel-title class="panel-header">
                <div class="reseller-header-content">
                  <h3>({{ reseller.province }}) {{ reseller.city }}</h3>
                  <div class="reseller-name">{{ reseller.name }}</div>
                  <div class="reseller-role">{{ reseller.title }}</div>
                </div>
              </v-expansion-panel-title>
              
              <v-expansion-panel-text>
                <div class="reseller-details">
                  <div class="detail-row">
                    <div class="detail-group" v-if="reseller.email || reseller.phone">
                       <h4>Contatti</h4>
                       <a :href="`mailto:${reseller.email}`" v-if="reseller.email" class="contact-link">
                         <v-icon size="x-small">mdi-email</v-icon> {{ reseller.email }}
                       </a>
                       <a :href="`tel:${reseller.phone}`" v-if="reseller.phone" class="contact-link">
                         <v-icon size="x-small">mdi-phone</v-icon> {{ reseller.phone }}
                       </a>
                    </div>
                    
                    <div class="detail-group">
                      <h4>Comuni di attività</h4>
                      <span>{{ reseller.activityCities }}</span>
                    </div>
                  </div>

                  <div class="description-group" v-if="reseller.description">
                    <h4>Cosa faccio</h4>
                    <div class="html-desc" v-html="reseller.description"></div>
                  </div>
                </div>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </div>
    
    </div>
  </div>
</template>

<script>
import apiService from "@/services/ApiService";
import {getTranslation} from "@/services/stringTableService";
import _ from "lodash";

export default {
  name: 'ResellerList',
  data() {
    return {
      resellers: [],
      filteredResellers: [],
      searchQuery: "",
      language: "IT",
      panels: []
    }
  },
  methods: {
    getTranslation(key) {
      return getTranslation(this.language, key);
    },
    debouncedSearch: _.debounce(function() {
      if (!this.searchQuery || this.searchQuery.length === 0) {
        this.filteredResellers = this.resellers;
        return;
      }

      const query = this.searchQuery.toLowerCase();
      this.filteredResellers = this.resellers.filter(reseller => {
      return (reseller?.name || '').toLowerCase().includes(query) ||
        (reseller?.city || '').toLowerCase().includes(query) ||
        (reseller?.province || '').toLowerCase().includes(query) ||
        (reseller?.activityCities || '').toLowerCase().includes(query) ||
        (reseller?.title || '').toLowerCase().includes(query);
      });
    }, 300)
  },
  async beforeMount() {
    try {
      this.$store.dispatch('setLoading', true); // Changed from false to true for initial load
      let resellers = (await apiService.getResellers());

      resellers = resellers.sort((a, b) => {
          const nameA = (a.province || '').toUpperCase();
          const nameB = (b.province || '').toUpperCase();
          return nameA < nameB ? -1 : (nameA > nameB ? 1 : 0);
      });
      this.resellers = resellers;
      this.filteredResellers = this.resellers;

    } catch (e) {
      console.error(e);
    } finally {
      this.$store.dispatch('setLoading', false);
    }
  }
}
</script>

<style scoped lang="scss">
@import "../style/_variables.scss";

.reseller-list-wrapper {
  background-color: $background-color;
  min-height: 100dvh;
  padding: 10px 0px 40px;
  color: $text-color;    
  width: 100%;
  
  .container {
    max-width: 900px; // Slightly narrower for list readability
    margin: 0 auto;
    padding: 0 1rem;
  }
}

// Navigation (Matches ProductDetail)
.nav-header {
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 2rem;
  
  .nav-left {
    display: flex;
    align-items: center;
    gap: 1rem;
    cursor: pointer;
  }
  
  .back-btn {
    background: rgba(255,255,255,0.05);
    color: white;
    &:hover { background: $primary-gradient; }
  }
  
  .nav-title {
    font-family: $header-font;
    text-transform: uppercase;
    font-weight: bold;
    color: #ccc;
    font-size: 0.9rem;
    &:hover { color: white; }
  }

  .nav-logo-link {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
  }
  
  .header-logo {
     height: 60px;
     width: auto;
     transition: transform 0.3s;
     &:hover { transform: scale(1.1); }
  }
}

// Page Title
.page-title {
  text-align: center;
  font-family: $header-font;
  font-size: 2rem;
  text-transform: uppercase;
  color: white;
  margin-bottom: 0.5rem;
}
.title-underline {
  width: 60px;
  height: 4px;
  background: $primary-gradient;
  border-radius: 2px;
  margin: 0 auto 2rem;
}

// Search
.search-container {
  margin-bottom: 2rem;
  padding: 5px 20px;
  border-radius: 50px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s;
  
  &:focus-within {
    background: rgba(255, 255, 255, 0.1);
    border-color: $secondary-color;
    box-shadow: 0 0 15px rgba($secondary-color, 0.2);
  }
}
:deep(.custom-search-field) {
  input { color: white !important; }
  label { color: #aaa !important; }
  .v-icon { color: #888; }
}

// Lists
.reseller-section {
  margin-bottom: 2rem;
}

// Custom Expansion Panels
:deep(.custom-reseller-panels) {
  .v-expansion-panel {
    background: transparent !important;
    border: 1px solid rgba(255,255,255,0.05);
    border-radius: 12px !important;
    overflow: hidden;
    transition: background-color 0.3s ease, border-color 0.3s ease;
    
    &::before { opacity: 0; }
    
    &.featured-panel {
      border: 1px solid rgba($secondary-color, 0.3);
      background: rgba($secondary-color, 0.05) !important;
      .badge {
        background: $primary-gradient;
        color: white;
        padding: 4px 8px;
        border-radius: 4px;
        font-size: 0.7rem;
        text-transform: uppercase;
        font-weight: bold;
        display: inline-block;
        margin-bottom: 5px;
      }
    }
    
    &:hover {
      background: rgba(255,255,255,0.03) !important;
      border-color: rgba(255,255,255,0.2);
    }
    
    .panel-header {
      padding: 1.5rem;
      min-height: auto;
      
      .reseller-header-content {
        text-align: left;
        width: 100%;
        
        .location-badge {
          display: inline-block;
          font-family: $header-font;
          font-weight: bold;
          color: $secondary-color;
          border: 1px solid $secondary-color;
          padding: 2px 6px;
          border-radius: 4px;
          font-size: 0.8rem;
          margin-bottom: 5px;
        }
        
        h3 {
          font-size: 1.2rem;
          color: white;
          margin: 0;
          line-height: 1.3;
        }
        
        .reseller-name {
          font-size: 1rem;
          margin-top: 4px;
        }
        
        .reseller-role {
          font-size: 0.85rem;
          margin-top: 2px;
          font-style: italic;
        }
        
        .subtitle {
          color: #ccc;
          font-size: 0.9rem;
          margin-top: 5px;
        }
      }
    }
    
    .v-expansion-panel-text {
      /* Reset Vuetify default padding if necessary, or just safeguard */
      :deep(.v-expansion-panel-text__wrapper) {
        padding: 0 !important;
      }
    
      .reseller-details {
        padding: 1rem 1.5rem 2rem;
        border-top: 1px solid rgba(255,255,255,0.05);

        display: flex;
        flex-direction: column;
        gap: 1.5rem;
        
        h4 {
          color: $secondary-color;
          font-family: $header-font;
          font-size: 0.95rem;
          margin-bottom: 0.5rem;
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }
        
        .detail-row {
          display: flex;
          flex-wrap: wrap;
          gap: 2rem;
        }
        
        .contact-link {
          display: block;
          color: #ddd;
          text-decoration: none;
          margin-bottom: 5px;
          transition: color 0.2s;
          display: flex;
          align-items: center;
          gap: 8px;
          
          &:hover { color: white; text-decoration: underline; }
        }
        
        .html-desc {
          color: #bbb;
          font-size: 0.95rem;
          line-height: 1.6;
        }
        
        span { color: #ccc; }
      }
    }
  }
}

// Animations
.animate-fade-in { animation: fadeIn 0.8s ease forwards; }
.content-animate-up { 
  opacity: 0;
  animation: fadeUp 0.8s ease forwards 0.2s; 
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes fadeUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

// Media Queries
@media (max-width: 600px) {
  .nav-header {
    justify-content: space-between;
    gap: 1rem;
    .nav-logo-link {
       position: static;
       transform: none;
    }
  }
  
  .detail-row {
    flex-direction: column;
    gap: 1rem !important;
  }
}
</style>